import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { RootState } from 'store';

import CompanyBillingMapForm from 'screens/components/CompanyBillingMapForm';

const CompanyBillingMapEditContainer = () => {
  const { selected } = useSelector((state: RootState) => state.addresses);
  const history = useHistory();

  useEffect(
    () => {
      if (!selected) {
        history.push('/companyBillingAddressEdit', history.location.state);
        return;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
  return <CompanyBillingMapForm />;
};

export default CompanyBillingMapEditContainer;
